import { DEFAULT_STATE } from '../constants'

export const initialLicensesState = {
  licenses: DEFAULT_STATE.licenses,
  contentSafetyLicenses: DEFAULT_STATE.contentSafetyLicenses,
}
